class recentlyProducts extends HTMLElement {
  constructor() {
    super();
    this.recentlyViewed = [];
    this.container = document.querySelector('.recently-viewed-main');
    this.embla = null;

    this.manageRecentlyViewed();
  }
  
  manageRecentlyViewed(){
    if (!this.container) return;
    let getRecentlyViewed = localStorage.getItem("user_recently_viewed");
    if (getRecentlyViewed != null) {
      this.recentlyViewed = JSON.parse(getRecentlyViewed);        
      this.recentlyViewed.reverse();

      // Limit to 8 most recent — prevents excessive parallel price-refresh fetches
      if(this.recentlyViewed.length > 0) this.showRecentlyViewed(this.recentlyViewed.slice(0, 8));
    }
    
    if(window.globalSpace.template == 'product' && window.globalSpace.product.price > 0){
      const productData = window.globalSpace.product;
      let requiredData = {
        id: productData.id,
        handle: productData.handle,
        title: productData.title,
        price: productData.price,
        compared_at_price: productData.compare_at_price,
        image: productData.featured_image,
        tags: productData.tags,
        reviews_count: window.globalSpace.reviews_count
      }
      this.addToRecentlyViewed(requiredData);
    }
  }

  async showRecentlyViewed(products) {
    // Fetch updated prices for all products in parallel — no main-thread blocking
    const updatedProducts = await Promise.all(
      products.map(async (product) => {
        if (!product.handle) return product;
        try {
          const response = await fetch(`/products/${product.handle}.js`);
          if (response.ok) {
            const apiProduct = await response.json();
            return { ...product, ...this.getCardPricing(apiProduct) };
          }
        } catch(e) {
          // silently fall back to cached data
        }
        return product;
      })
    );

    let recentlyViewedHTML = '';
    let totalProducts = 0;
    updatedProducts.forEach(product => {
      const currentProduct = window.globalSpace.product?.id || null;
      const currentIndex = product.id == currentProduct;
      const productTags = product.tags;

      // Fetch failed: cached product-level prices may mix variants, so only show the price
      const pricing = product.pricing || { priceVaries: false, price: product.price, compareAtPrice: null, discountPercentage: 0 };
      const formatMoney = (cents) => Utility.formatMoney(cents, window.globalSpace.money_format);
      const priceText = pricing.priceVaries
        ? window.variantStrings.priceRange.replace('[min]', formatMoney(pricing.priceMin)).replace('[max]', formatMoney(pricing.priceMax))
        : formatMoney(pricing.price);
      const badgeText = pricing.priceVaries
        ? window.variantStrings.upToOff.replace('[percent]', pricing.discountPercentage)
        : window.variantStrings.percentOff.replace('[percent]', pricing.discountPercentage);

      if(currentIndex == false && product.price > 0){
        totalProducts += 1;
        recentlyViewedHTML += `
        <div class="embla__slide recently-viewed__slide">
          <div class="card card-product card-product-style-1 text-start rounded-0 border-0">
            <div class="product--media product-images-wrapper mb-3 position-relative">
              <div class="product--media square">
              <span class="badges">
                  ${productTags?.includes('Lab Grown Diamond') ? `<span class="badge badge-best-seller">${window.badgeStrings.lab_grown_diamond}</span>` : ''}
                  ${productTags?.includes('moissanite') ? `<span class="badge badge-new">${window.badgeStrings.moissanite}</span>` : ''}
                </span>
                <a href="/products/${product.handle}" class="d-block product-link position-relative">
                  <img src="${product.image}" alt="${product.title}">
                </a>
              </div>
            </div>

            <div class="card-body bg-white ps-0 pe-0">
              <a href="/products/${product.handle}" class="h2 d-block mb-1 card-product-title fs-base left text-start fw-semibold text-math-auto">${product.title}</a>
              <div class="price-block mb-4 text-left">
                <div class="product-price-selector d-flex flex-wrap align-items-center gap-1 justify-content-between">
                  <div class="gap-1 d-flex flex-wrap align-items-end" id="product-price-selector">
                      <span class="price m-0 p-0 money" data-currentprice="">${priceText}</span>
                      ${pricing.compareAtPrice ? `<del class="price small m-0 p-0 money d-inline-block compare-price" data-compareprice="">${formatMoney(pricing.compareAtPrice)}</del>` : ''}
                  </div>
                  ${pricing.discountPercentage > 0 ? `<span class="discount-percentage text-primary-500 bg-primary-200 rounded fs-md fw-semibold d-inline-block">${badgeText}</span>` : ''}
                </div>
                <div class="pdp-star-rating d-flex align-items-center gap-1 fs-md">
                  ${product.reviews_count != null ? `<div class="">${product.reviews_count}</div>` : ''}
                </div>
              </div>
            </div>

          </div>
        </div>`;
      }
    });

    if(totalProducts > 0){
      let sliderHTML = `
        <div class="recently-viewed-embla" data-embla data-embla-prev=".button-prev-recently-viewed" data-embla-next=".button-next-recently-viewed">
          <div class="embla__viewport" data-embla-viewport>
            <div class="embla__container recently-viewed__container" data-embla-container>
              ${recentlyViewedHTML}
            </div>
          </div>
          <div class="custom-swiper-navigation inside">
            <button class="swiper-button-prev button-prev-recently-viewed is-disabled" type="button" aria-label="Previous slide"><svg aria-hidden="true" focusable="false"><use href="#icon-arrow-left"></use></svg></button>
            <button class="swiper-button-next button-next-recently-viewed" type="button" aria-label="Next slide"><svg aria-hidden="true" focusable="false"><use href="#icon-arrow-right"></use></svg></button>
          </div>
        </div>`;

      this.container.classList.remove('d-none');
      this.container.querySelector("recently-products").innerHTML = sliderHTML;

      // Initialize Embla after DOM is updated
      this.initEmbla();
    }
  }

  initEmbla() {
    if (typeof EmblaCarousel === 'undefined') {
      console.error('[Recently Viewed] EmblaCarousel is undefined');
      return;
    }

    const emblaRoot = this.container.querySelector('.recently-viewed-embla');
    const viewport = emblaRoot.querySelector('[data-embla-viewport]');
    const prevBtn = emblaRoot.querySelector('.button-prev-recently-viewed');
    const nextBtn = emblaRoot.querySelector('.button-next-recently-viewed');

    if (!viewport) {
      console.warn('[Recently Viewed] Missing viewport');
      return;
    }

    const options = {
      align: 'start',
      loop: false,
      containScroll: 'trimSnaps',
      dragFree: false,
      slidesToScroll: 1,
    };

    this.embla = EmblaCarousel(viewport, options);

    // Navigation button click handlers
    if (prevBtn) prevBtn.addEventListener('click', () => this.embla.scrollPrev(), { passive: true });
    if (nextBtn) nextBtn.addEventListener('click', () => this.embla.scrollNext(), { passive: true });

    // Update navigation buttons state (add/remove is-disabled class)
    const updateNavButtons = () => {
      if (prevBtn) {
        prevBtn.disabled = !this.embla.canScrollPrev();
        prevBtn.classList.toggle('is-disabled', !this.embla.canScrollPrev());
      }
      if (nextBtn) {
        nextBtn.disabled = !this.embla.canScrollNext();
        nextBtn.classList.toggle('is-disabled', !this.embla.canScrollNext());
      }
    };

    this.embla.on('select', updateNavButtons);
    this.embla.on('reInit', updateNavButtons);
    updateNavButtons(); // Set initial state

    // Store embla instance on element for debugging
    emblaRoot.embla = this.embla;
  }

  /**
   * Card pricing from a /products/{handle}.js response, matching snippets/card-product-price.liquid:
   * a range plus the largest variant discount when prices vary, otherwise one variant's price and compare-at.
   */
  getCardPricing(apiProduct) {
    const variants = apiProduct.variants || [];
    const availableVariants = variants.filter((variant) => variant.available);
    const discountOf = (variant) => (variant && variant.compare_at_price > variant.price)
      ? Math.floor((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) : 0;

    if (apiProduct.price_varies) {
      const pool = availableVariants.length ? availableVariants : variants;
      return {
        price: apiProduct.price,
        pricing: {
          priceVaries: true, priceMin: apiProduct.price_min, priceMax: apiProduct.price_max,
          compareAtPrice: null, discountPercentage: Math.max(0, ...pool.map(discountOf)),
        },
      };
    }

    const variant = availableVariants[0] || variants[0];
    const price = variant ? variant.price : apiProduct.price;
    const discountPercentage = discountOf(variant);
    return {
      price,
      pricing: { priceVaries: false, price, compareAtPrice: variant?.compare_at_price > price ? variant.compare_at_price : null, discountPercentage },
    };
  }

  addToRecentlyViewed(product) {
    const productExist = this.recentlyViewed.findIndex((x) => {
      return x.id == product.id;
    });

    if (productExist == -1) {
      this.recentlyViewed.push(product);
      if (this.recentlyViewed.length > 20) this.recentlyViewed.shift();
      localStorage.setItem(
        "user_recently_viewed",
        JSON.stringify(this.recentlyViewed)
      );
    }
  }
}
customElements.define("recently-products", recentlyProducts);